import { PopupText } from "app/widgets/referral-modal/referral-modal";

export interface WelcomeBanner {
  title: string;
  description: string;
}

export interface Participation {
  id: string;
  projectName: string;
  poolName: string;
  tokenPrice: string;
  timeLeft: string;
  projectUrl: string;
  logoUrl: string;
}

export const welcomeBanner: WelcomeBanner = {
  title: "Don’t forget to spin today!",
  description: "",
};

export const participations: Participation[] = [
  {
    id: "1",
    projectName: "GoodcryptoX",
    poolName: "Magic Members",
    tokenPrice: "$0.0225",
    timeLeft: "4d 16h 56m 59s",
    projectUrl: "",
    logoUrl: "",
  },
  {
    id: "2",
    projectName: "GoodcryptoX",
    poolName: "GoodcryptoX Community",
    tokenPrice: "$0.0225",
    timeLeft: "4d 16h 56m 59s",
    projectUrl: "",
    logoUrl: "",
  },
];

export const dashboardTexts = {
  title: "Welcome to AlphaMind!",
  text: "This is your private dashboard area to monitor daily activity, check Karma score, get shortcut access to the quests, and access web3 alpha projects!",
  header: "Personal Dashboard",
};

export const tierData = [
  {
    name: "1. Alpha",
    tierKey: "Alpha",
    punch: "Top 5% ",
    first: "of all users based on Karma balance.",
    second: "First-Level Priority Access to IDOs",
    third: "0 Fees Commission on Pre-Orders Withdrawal",
    four: "Up to 2.5X Staking Rewards",
    five: "Top Ecosystem Perks, Alpha Drops, etc.",
    six: "VIP Alpha Group Access",
    seven: "Other Benefits",
    tooltip:
      "Depending on the amount of users in each tier, the size of the allocation may vary",
  },
  {
    name: "2. Beta",
    tierKey: "Beta",
    punch: "81%-94% ",
    first: "of all users based on Karma balance.",
    second: "Priority Access to IDOs",
    third: "75% Discount on Pre-Orders Withdrawals Commission",
    four: "Up to 2X Staking Rewards",
    five: "Top Ecosystem Perks",
    six: "Other Benefits",
    tooltip:
      "Depending on the amount of users in each tier, the size of the allocation may vary",
  },
  {
    name: "3. Gamma",
    tierKey: "Gamma",
    punch: "41%-80% ",
    first: "of all users based on Karma balance.",
    second: "Early Access to IDOs",
    third: "50% Discount on Pre-Orders Withdrawals Commission",
    four: "Up to 1,5X Staking Rewards",
    five: "Access to Ecosystem Perks",
    six: "Other Benefits",
    tooltip:
      "Depending on the amount of users in each tier, the size of the allocation may vary",
  },
  {
    name: "4. Beginner",
    tierKey: "Beginner",
    punch: "Lower 40% ",
    first: "of all users based on Karma balance",
    second: "Early Access to IDOs",
    third: "25% Discount on Pre-Orders Withdrawals Commission",
    four: "Up to 1,25X Staking Rewards",
    five: "Other Benefits",
    tooltip:
      "Depending on the amount of users in each tier, the size of the allocation may vary",
  },
];

export const popupText: PopupText = {
  title: "Refer a friend and build Karma together.",
  description:
    "You will receive 20% of Karma they acquire after your referrals complete at least one task.",
  copyText: "Copy the link below to start inviting your network!",
  hasCopyLink: true,
  cta: "Build Network",
  errorTitle: "Ooops... Something wrong!",
  errorText: "Please, refresh the page",
};
